import { useMutationFormeBackendApi } from "@modules/forme/queries";

const DOCUSIGN_URL = "/v1/clients/docusign";

type UseDocusignSignNowInput = {
  advisorEmail: string;
  advisorName: string;
  redirectUrl: string;
  templateKey: "wma" | "wda";
  isCoClientEmbeddedSigner: boolean;
  isCoClient: boolean;
};

type UseDocusignSignNowOutput = {
  envelopeId: string;
  redirectUrl: string;
};

const useDocusignSignNow = () => {
  return useMutationFormeBackendApi<
    UseDocusignSignNowOutput,
    UseDocusignSignNowInput
  >({
    method: "POST",
    path: DOCUSIGN_URL,
  });
};

export { useDocusignSignNow };
